export default function auth({ next, store }) {
  if (store.getters['auth/isAuth']) {
    next();
  } else {
    next({ name: 'users:login' });
  }
}
